import { InjectionToken } from '@angular/core';
import { DictionaryRepository } from '@softline/core';
import { LastUsed } from './last-used';

export const SOFTLINE_REPOSITORY_LAST_USED = new InjectionToken<DictionaryRepository<LastUsed<any>[], LastUsed<any>[]>>('SOFTLINE_REPOSITORY_LAST_USED')
export const SOFTLINE_NAME_LAST_USED_OBJECT_STORE = 'last-used';
